export const DOCS_URL = "https://eng.ms/docs/excalidraw";
export const REPOSITORY_URL = "https://msft.ghe.com/cacore/Excalidraw-MS";
export const CONTRIBUTOR_ACCESS_URL =
  "https://myaccess.microsoft.com/@msesmecloud.onmicrosoft.com#/access-packages/334c100f-6912-4f3e-9cf2-d0a72d2b51c6";
